import React, { useRef } from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { useApp } from '../../context/app-context';

const iconContainerStyle = css`
  display: flex;
  align-content: center;
  align-items: center;
  background: 0;
  border: 0;
  padding: 0;
`;

const iconStyle = css`
  cursor: pointer;
`;

const OrderInfoIcon = ({ width, height, className, popoverContent, analyticsPageView, label }) => {
  const iconRef = useRef(null);
  const { showTooltip } = useApp();

  const analyticsEvents = (name) => {
    try {
      if (window['AB']?.DATALAYER) {
        window['AB']?.DATALAYER.setLinkClickEvents(name);
      }
    } catch (error) {
      // Handle any errors that occur during execution
      console.error('@AnalyticsTeam error:', error);
    }
  };

  const showPopOver = (evt) => {
    evt.stopPropagation();
    showTooltip({ message: popoverContent, target: get(evt, 'target') });

    if (analyticsPageView === 'pendingOrder') {
      analyticsEvents('ar:subscribe-schedule-and-save|estimated-sub-total');
    }
  };

  return (
    <>
      <button
        className={`${className || ''} ${iconContainerStyle}`}
        ref={iconRef}
        onClick={showPopOver}
        aria-label={label}
      >
        <svg
          width={width || height || '22'}
          height={height || width || 22}
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={iconStyle}
          aria-hidden={true}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0004 1.5394C5.77551 1.5394 1.53988 5.77502 1.53988 10.9999C1.53988 16.2248 5.77551 20.4605 11.0004 20.4605C16.2253 20.4605 20.4609 16.2248 20.4609 10.9999C20.4609 5.77502 16.2253 1.5394 11.0004 1.5394ZM0.460938 10.9999C0.460938 5.17913 5.17962 0.460449 11.0004 0.460449C16.8212 0.460449 21.5399 5.17913 21.5399 10.9999C21.5399 16.8207 16.8212 21.5394 11.0004 21.5394C5.17962 21.5394 0.460938 16.8207 0.460938 10.9999Z"
            fill="#2A2928"
          />
          <path
            d="M11.5879 16.235C11.4275 16.4116 11.2233 16.4999 10.9754 16.4999C10.7275 16.4999 10.516 16.4116 10.341 16.235C10.1806 16.0583 10.1004 15.8522 10.1004 15.6167V9.58152C10.1004 9.346 10.1806 9.13992 10.341 8.96328C10.516 8.78664 10.7275 8.69832 10.9754 8.69832C11.2233 8.69832 11.4275 8.78664 11.5879 8.96328C11.7629 9.13992 11.8504 9.346 11.8504 9.58152V15.6167C11.8504 15.8522 11.7629 16.0583 11.5879 16.235ZM11.5879 7.1196C11.4275 7.28152 11.2233 7.36248 10.9754 7.36248C10.7275 7.36248 10.516 7.28152 10.341 7.1196C10.1806 6.94296 10.1004 6.72952 10.1004 6.47928V5.88312C10.1004 5.6476 10.1806 5.44152 10.341 5.26488C10.516 5.08824 10.7275 4.99992 10.9754 4.99992C11.2233 4.99992 11.4275 5.08824 11.5879 5.26488C11.7629 5.44152 11.8504 5.6476 11.8504 5.88312V6.47928C11.8504 6.72952 11.7629 6.94296 11.5879 7.1196Z"
            fill="#2A2928"
          />
        </svg>
      </button>
    </>
  );
};

OrderInfoIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  popoverContent: PropTypes.string,
  label: PropTypes.string,
};

export default OrderInfoIcon;
